import type { SYSAction } from "../../../../_ovlclient/src"
import { TableRefresh } from "../../../../_ovlclient/src/library/table/tableapi"

const HookScreenRefresh: SYSAction = async (_) => {
  await TableRefresh("SYSEPT")
}

const HookScreenNavigateIn = async (_, { state, actions }) => {
  await TableRefresh("SYSEPT")
}

export let SYSEPT = { hooks: { HookScreenNavigateIn, HookScreenRefresh } }
